export default "<ngx-loading\n  data-test-id=\"ngx-loader\"\n  [show]=\"show\"\n  [config]=\"config\"\n  [template]=\"template\">\n</ngx-loading>\n"